(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["index-vertical-mega-menu"]) return;
  try {
    
$("#init-toggle").click(function(){
    $(this).toggleClass('open');
    $(".vertical-mega-menu").toggleClass('open');
  });

  const initToggle = document.getElementById("init-toggle");
  const menuVert = document.querySelector(".vertical-mega-menu");
  document.addEventListener("scroll",()=>{
    if(window.scrollY > 200 && !initToggle.classList.contains("sticky-sticky")){
      /* console.log(menuVert); */
      initToggle.classList.add("sticky-sticky");
      menuVert.classList.add("menu-sticky2");
    }
    else if(window.scrollY <= 200 && initToggle.classList.contains("sticky-sticky")){
      initToggle.classList.remove("sticky-sticky");
      menuVert.classList.remove("menu-sticky2");
    }
  })


  } catch(e) { console.error(e); }
})();
      })();
